// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_-4f3L","wrapper":"wrapper_pjs8f"};